<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<!-- 新增候选人 -->
		<Addperson @dataList="dataList" ref="addperson" :user_id='getdata.user_id' :flag="getdata.flag"></Addperson>
		<!-- 党委打分 -->
		<Dwdf ref="dwfd" :tableHeader="tableHeader" @dataList="dataList"></Dwdf>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党务工作</el-breadcrumb-item>
				<el-breadcrumb-item>年终考核</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<el-select
							size="small"
							style="width: 120px !important;" 
							v-model="getdata.year" placeholder="请选择年份"
							@change="getdata.page = 1;totalPage = 0;dataList();"
							clearable>
							<el-option
								:key="item"
								v-for="item in $yearList()"
								:label="item"
								:value="item">
							</el-option>
						</el-select>
						<div style="display:flex;algin-items:center">
							<el-upload
								:data="{token:$store.state.user.userinfo.token}"
								v-if="$store.state.user.userinfo.flag == 1"
								name="file"
								style="margin-right:10px;"
								:action="$uploadFile"
								:show-file-list="false"
								:limit="4"
								:on-success="success1"
								:on-progress="uploadProcess"
								:before-upload="limitFiles">
								<el-button size="small" type="primary">上传附件</el-button>
							</el-upload>
							<el-button type="primary" size="small" @click="$router.push('/pfxz1')">评分细则</el-button>
							<el-button type="primary" size="small"
							v-if="$store.state.user.userinfo.flag==3"
							 @click="$refs.addperson.openWin(true)">新增候选人</el-button>
							<el-button type="primary" size="small"
							v-if="$store.state.user.userinfo.flag==3"
							 @click="putOut">导出表格</el-button>
						</div>
					</div>
					<!-- <div class="result">
						<span>结果说明：</span>
						<span>{{shuoming}}</span>
					</div> -->
					<div class="selectdata">
						<template>
							<el-table
								:header-cell-style="{background:'#f5f7fa',color:'#000'}"
								:data="tableData"
								stripe
								show-overflow-tooltip
								border
								style="width: 100%">
								<el-table-column 
									prop="u_name"
									label="候选人" 
									fixed="left">
								</el-table-column>
								<el-table-column 
									:key="index"
									v-for="(item,index) in tableHeader"
									:prop="item.score"
									:label="item.class_name+'('+item.score+')'" 
									width="110">
									<template slot-scope="scope">
										{{scope.row.score[index]}}
									</template>
								</el-table-column>
								<el-table-column 
									prop="total_score"
									label="总分">
								</el-table-column>
								<el-table-column 
									prop="res"
									label="结果">
								</el-table-column>
								<el-table-column
									label="操作"
									width="120"
									v-if="$store.state.user.userinfo.flag==3"
									fixed="right">
									<template slot-scope="scope">
										<el-button type="text"
											@click="$refs.dwfd.openWin(scope.row)">
											{{scope.row.res?'重新打分':'打分'}}
										</el-button>
										<el-button type="text" @click="del(scope.row)">删除</el-button>
									</template>
								</el-table-column>
							</el-table>
						</template>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
						<div class="dwfile" v-if="dwFliesSub.files">
							<div class="filelabel">附件：</div>
							<div class="files">
								<div class="file" 
								:key="index"
									v-for="(item,index) in dwFliesSub.files">
									<div>{{item.title}}</div>
									<i class="el-icon-close" 
									@click="delDwFiles(item.id)" 
									v-if="$store.state.user.userinfo.flag==1"></i>
									<i class="el-icon-download"
									 @click="zbDownloadFile(item.url)"
									 v-else></i>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Index from './mixins/index.js'
	export default {
		mixins:[Index]
	}
</script>

<style lang="scss">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.switchBar{
			width: 100%;
			height: 40px;
			line-height: 40px;
			margin-bottom: 20px;
			border-bottom: 1px solid #DDDDDD;
			span{
				cursor: pointer;
				display: inline-block;
				line-height: 40px;
				font-size: 16px;
				margin-right: 20px;
				padding: 0 20px;
				font-weight: bold;
			}
			span:hover{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
			.selectSwitch{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
		}
	}
	.result{
		color: #3C4353;
		font-size: 14px;
		line-height: 19px;
		display: flex;
		margin-bottom: 20px;
		span:nth-child(1){
			width: 100px;
			font-weight: bold;
		}
	}
</style>

